import React from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';
import {UserThemeConsumer} from '../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {SheetEmoji} from '../../../components/common/emoji/sheetEmoji';
import {getEmojiHighlight} from '../../../helpers/models/highlightHelpers';
import {HighlightTypesEnum} from '../../../models/api/highlightBaseModel';
import {StyledEllipsisWrapperDiv} from '../../components/reportViewer/reportCommons';
import {HighlightData, MetricTagRenderer} from '../analyticsFormatHelpers';

/*
 * Styles.
 */

const StyledInlineIcon = styled(Icon)`
  display: inline-block;
  vertical-align: middle;
`;

const StyledArchivedBadge = styled.div`
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.veryTiny};
  color: ${(p) => p.theme.greys.shade80};
  text-transform: uppercase;
  padding: 3px 5px 3px;
  background-color: ${(p) => p.theme.alphas.gray20};
  border-radius: 100px;
  display: inline-block;
  margin-left: 7px;
  line-height: 1;
  vertical-align: middle;
  margin-top: -1px;
`;

const StyledTagName = styled.div`
  ${ellipsis()}
  margin-left: 7px;
  padding-right: 6px;
`;

/*
 * Formatter.
 */

const renderHighlightBadge = (props: HighlightData) => {
  if (props.type === HighlightTypesEnum.EMOJI) {
    const definition = getEmojiHighlight(props);
    if (definition) {
      return <SheetEmoji emoji={definition.emoji} skinTone={definition.skinTone} size={16} />;
    }
  }

  return (
    <UserThemeConsumer>
      {(theme) => (
        <StyledInlineIcon
          name="tagSmall"
          color={
            props.type === HighlightTypesEnum.COLOR
              ? theme.palette[props.highlightColor].shade40
              : theme.greys.shade70
          }
        />
      )}
    </UserThemeConsumer>
  );
};

export const renderTagValue: MetricTagRenderer = (props) => {
  const {value, isArchived, highlight} = props;

  return (
    <UserThemeConsumer>
      {() => (
        <StyledEllipsisWrapperDiv>
          {renderHighlightBadge(highlight)}
          {isArchived && (
            <StyledArchivedBadge>
              <Trans id="tag-archived">Archived</Trans>
            </StyledArchivedBadge>
          )}

          <StyledTagName>{value}</StyledTagName>
        </StyledEllipsisWrapperDiv>
      )}
    </UserThemeConsumer>
  );
};
